import { leftpad, angleReflect } from './utils';
const Phaser = window?.Phaser;
export class MultiPlayerBlitz extends window.Phaser.Scene {
  constructor() {
    super('multiPlayerBlitz');
  }

  init(data) {
    this.numPlayers = data.numPlayers;
  }

  preload() {
    this.scores = [0, 0, 0, 0];
    this.load.image('wall', '/assets/delivery-guy/wall.png');
    this.load.spritesheet(
      'hero-bird',
      '/assets/delivery-guy/sprite-drone.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'hero-bird-blue',
      '/assets/delivery-guy/sprite-drone-blue.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'hero-bird-green',
      '/assets/delivery-guy/sprite-drone-green.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'hero-bird-yellow',
      '/assets/delivery-guy/sprite-drone-yellow.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    /*
    this.load.spritesheet('sprite-play', '/assets/delivery-guy/sprite-play.png', { 
      frameWidth: 55, 
      frameHeight: 55
    });
    this.load.spritesheet('sprite-pause', '/assets/delivery-guy/sprite-pause.png', { 
      frameWidth: 37, 
      frameHeight: 37
    });
    */
    this.load.spritesheet(
      'sprite-bomb',
      '/assets/delivery-guy/sprite-bomb.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-radar',
      '/assets/delivery-guy/sprite-radar.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-orange',
      '/assets/delivery-guy/sprite-orange.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-pear',
      '/assets/delivery-guy/sprite-pear.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
    this.load.spritesheet(
      'sprite-banana',
      '/assets/delivery-guy/sprite-banana.png',
      {
        frameWidth: 55,
        frameHeight: 55,
      }
    );
  }

  create() {
    this.gameWidth = this.sys.game.canvas.width;
    this.gameHeight = this.sys.game.canvas.height;

    this.defaultTimer = 60;
    this.timer = 60;
    this.birdAngles = [-90, -90, -90, -90];
    this.birdVelocities = [300, 300, 300, 300];
    this.birdAngularVelocities = [200, 200, 200, 200];
    this.defaultNumBombs = 4;
    this.numBombs = 4;
    this.spacesCount = 121;
    this.bouncingLRs = [false, false, false, false];
    this.bouncingTB = [false, false, false, false];
    this.goBirds = [false, false, false, false];
    this.spaces = new Uint8Array(this.spacesCount);
    this.canContinue = true;

    this.stopwatch = this.time.addEvent({
      delay: 1000,
      callback: this.updateTimer,
      callbackScope: this,
      loop: true,
    });

    var graphics = this.add.graphics();
    graphics.lineStyle(2, 0xffffff); // starting point 85, 87
    graphics.strokeRect(87, 87, 306, 2, 1);
    graphics.strokeRect(85, 89, 2, 308, 1);
    graphics.strokeRect(87, 397, 306, 2, 1);
    graphics.strokeRect(393, 89, 2, 308, 1);
    graphics.lineStyle(2, 0x9badb7);
    graphics.strokeRect(89, 91, 302, 2, 1);
    graphics.strokeRect(85, 399, 2, 2, 1);
    graphics.strokeRect(87, 401, 306, 2, 1);
    graphics.strokeRect(393, 399, 2, 2, 1);

    this.wallsLR = this.add.group();
    this.wallsTB = this.add.group();

    let wallLeft = this.wallsLR.create(83, 90, 'wall');
    wallLeft.setScale(5, 306);
    wallLeft.setOrigin(0, 0);
    this.physics.world.enable(wallLeft);

    let wallTop = this.wallsTB.create(83, 85, 'wall');
    wallTop.setScale(314, 5);
    wallTop.setOrigin(0, 0);
    this.physics.world.enable(wallTop);

    let wallRight = this.wallsLR.create(392, 90, 'wall');
    wallRight.setScale(5, 306);
    wallRight.setOrigin(0, 0);
    this.physics.world.enable(wallRight);

    let wallBottom = this.wallsTB.create(83, 396, 'wall');
    wallBottom.setScale(314, 5);
    wallBottom.setOrigin(0, 0);
    this.physics.world.enable(wallBottom);

    this.coins = this.add.group();
    this.bombs = this.add.group();

    this.bird1 = this.physics.add.sprite(
      this.gameWidth * 0.25,
      this.gameHeight * 0.25,
      'hero-bird'
    );
    this.bird1.alive = true;
    this.anims.create({
      key: 'bye',
      frames: this.anims.generateFrameNumbers('hero-bird', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'hover',
      frames: this.anims.generateFrameNumbers('hero-bird', { frames: [0] }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'fly',
      frames: this.anims.generateFrameNumbers('hero-bird', {
        frames: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      }),
      frameRate: 12.5,
      repeat: -1,
    });
    this.bird1.setOrigin(0.5, 0.5);
    this.bird1.body.setSize(24, 24);
    this.bird1.angle = this.birdAngles[0];
    this.bird1.alpha = 0;
    this.bird1.playable = true;
    this.bird1.bouncingTB = false;
    this.bird1.bouncingLR = false;
    this.tweens.add({
      targets: this.bird1,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
    });
    this.bird1.allowGravity = false;
    this.bird1.setCollideWorldBounds(true);
    this.bird1.body.bounce.set(1, 1);
    this.bird1.setAngularVelocity(this.birdAngularVelocities[0]);
    this.bird1.index = 0;
    this.bird1.anims.play('hover');

    if (this.numPlayers > 1) {
      this.bird2 = this.physics.add.sprite(
        this.gameWidth * 0.75,
        this.gameHeight * 0.75,
        'hero-bird-blue'
      );
      this.bird2.alive = true;
      this.anims.create({
        key: 'bye-blue',
        frames: this.anims.generateFrameNumbers('hero-bird-blue', {
          frames: [0, 1, 2, 3, 4, 5, 6, 7],
        }),
        frameRate: 12.5,
        repeat: 0,
      });
      this.anims.create({
        key: 'hover-blue',
        frames: this.anims.generateFrameNumbers('hero-bird-blue', {
          frames: [0],
        }),
        frameRate: 12.5,
        repeat: 0,
      });
      this.anims.create({
        key: 'fly-blue',
        frames: this.anims.generateFrameNumbers('hero-bird-blue', {
          frames: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        }),
        frameRate: 12.5,
        repeat: -1,
      });
      this.bird2.setOrigin(0.5, 0.5);
      this.bird2.body.setSize(24, 24);
      this.bird2.angle = this.birdAngles[1];
      this.bird2.alpha = 0;
      this.bird2.playable = true;
      this.bird2.bouncingTB = false;
      this.bird2.bouncingLR = false;
      this.tweens.add({
        targets: this.bird2,
        alpha: 1,
        duration: 200,
        repeat: 0,
        ease: 'quad.in',
      });
      this.bird2.allowGravity = false;
      this.bird2.setCollideWorldBounds(true);
      this.bird2.body.bounce.set(1, 1);
      this.bird2.setAngularVelocity(this.birdAngularVelocities[1]);
      this.bird2.index = 1;
      this.bird2.anims.play('hover-blue');

      if (this.numPlayers > 2) {
        this.bird3 = this.physics.add.sprite(
          this.gameWidth * 0.75,
          this.gameHeight * 0.25,
          'hero-bird-green'
        );
        this.bird2.x = this.gameWidth * 0.25;
        this.bird3.alive = true;
        this.anims.create({
          key: 'bye-green',
          frames: this.anims.generateFrameNumbers('hero-bird-green', {
            frames: [0, 1, 2, 3, 4, 5, 6, 7],
          }),
          frameRate: 12.5,
          repeat: 0,
        });
        this.anims.create({
          key: 'hover-green',
          frames: this.anims.generateFrameNumbers('hero-bird-green', {
            frames: [0],
          }),
          frameRate: 12.5,
          repeat: 0,
        });
        this.anims.create({
          key: 'fly-green',
          frames: this.anims.generateFrameNumbers('hero-bird-green', {
            frames: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
          }),
          frameRate: 12.5,
          repeat: -1,
        });
        this.bird3.setOrigin(0.5, 0.5);
        this.bird3.body.setSize(24, 24);
        this.bird3.angle = this.birdAngles[2];
        this.bird3.alpha = 0;
        this.bird3.playable = true;
        this.bird3.bouncingTB = false;
        this.bird3.bouncingLR = false;
        this.tweens.add({
          targets: this.bird3,
          alpha: 1,
          duration: 200,
          repeat: 0,
          ease: 'quad.in',
        });
        this.bird3.allowGravity = false;
        this.bird3.setCollideWorldBounds(true);
        this.bird3.body.bounce.set(1, 1);
        this.bird3.setAngularVelocity(this.birdAngularVelocities[2]);
        this.bird3.index = 2;
        this.bird3.anims.play('hover-green');

        if (this.numPlayers > 3) {
          this.bird4 = this.physics.add.sprite(
            this.gameWidth * 0.75,
            this.gameHeight * 0.75,
            'hero-bird-yellow'
          );
          this.bird4.alive = true;
          this.anims.create({
            key: 'bye-yellow',
            frames: this.anims.generateFrameNumbers('hero-bird-yellow', {
              frames: [0, 1, 2, 3, 4, 5, 6, 7],
            }),
            frameRate: 12.5,
            repeat: 0,
          });
          this.anims.create({
            key: 'hover-yellow',
            frames: this.anims.generateFrameNumbers('hero-bird-yellow', {
              frames: [0],
            }),
            frameRate: 12.5,
            repeat: 0,
          });
          this.anims.create({
            key: 'fly-yellow',
            frames: this.anims.generateFrameNumbers('hero-bird-yellow', {
              frames: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
            }),
            frameRate: 12.5,
            repeat: -1,
          });
          this.bird4.setOrigin(0.5, 0.5);
          this.bird4.body.setSize(24, 24);
          this.bird4.angle = this.birdAngles[3];
          this.bird4.alpha = 0;
          this.bird4.playable = true;
          this.bird4.bouncingTB = false;
          this.bird4.bouncingLR = false;
          this.tweens.add({
            targets: this.bird4,
            alpha: 1,
            duration: 200,
            repeat: 0,
            ease: 'quad.in',
          });
          this.bird4.allowGravity = false;
          this.bird4.setCollideWorldBounds(true);
          this.bird4.body.bounce.set(1, 1);
          this.bird4.setAngularVelocity(this.birdAngularVelocities[3]);
          this.bird4.index = 3;
          this.bird4.anims.play('hover-yellow');
        }
      }
    }

    // create fruit animations
    this.anims.create({
      key: 'apple-bye',
      frames: this.anims.generateFrameNumbers('sprite-radar', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'orange-bye',
      frames: this.anims.generateFrameNumbers('sprite-orange', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'pear-bye',
      frames: this.anims.generateFrameNumbers('sprite-pear', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'banana-bye',
      frames: this.anims.generateFrameNumbers('sprite-banana', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      }),
      frameRate: 12.5,
      repeat: 0,
    });

    // create bomb animations
    this.anims.create({
      key: 'bomb-shine',
      frames: this.anims.generateFrameNumbers('sprite-bomb', {
        frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      }),
      frameRate: 12.5,
      repeat: 0,
    });
    this.anims.create({
      key: 'bomb-bye',
      frames: this.anims.generateFrameNumbers('sprite-bomb', {
        frames: [10, 11, 12, 13, 14, 15, 16],
      }),
      frameRate: 12.5,
      repeat: 0,
    });

    this.createACoin(true);

    for (var i = 0; i < this.numBombs; i++) {
      this.createABomb();
    }

    this.timerText = this.add
      .bitmapText(85, 62, 'pixelfont', '60', 16)
      .setOrigin(0, 0);
    this.splitText = this.add
      .bitmapText(117, 62, 'pixelfont', '/', 16)
      .setOrigin(0, 0);

    let tintLengths = [0, 0, 0, 0];
    let scoreTextContent = '';
    for (let i = 0; i < this.numPlayers; i++) {
      let playerNum = i + 1;
      let playerScore = `P${playerNum}: ${this.scores[i]} `;
      scoreTextContent += playerScore;
      tintLengths[i] = playerScore.length;
    }
    this.scoreText = this.add
      .bitmapText(133, 62, 'pixelfont', scoreTextContent, 16)
      .setOrigin(0, 0);
    this.scoreText.setCharacterTint(0, tintLengths[0], true, 0xff2f56);
    this.scoreText.setCharacterTint(
      tintLengths[0],
      tintLengths[1],
      true,
      0x1b98e0
    );
    if (this.numPlayers > 2) {
      this.scoreText.setCharacterTint(
        tintLengths[0] + tintLengths[1],
        tintLengths[2],
        true,
        0x0ead69
      );
      if (this.numPlayers > 3) {
        this.scoreText.setCharacterTint(
          tintLengths[0] + tintLengths[1] + tintLengths[2],
          tintLengths[3],
          true,
          0xf2dc5d
        );
      }
    }

    tintLengths = [7, 5, 0, 0];
    let controlsTextContent = 'P1: A  P2: L';
    if (this.numPlayers > 2) {
      controlsTextContent = 'P1: Q  P2: C  P3: Y';
      tintLengths = [7, 7, 5, 0];
      if (this.numPlayers > 3) {
        controlsTextContent += '  P4: L';
        tintLengths = [7, 7, 7, 5];
      }
    }
    this.controlsText = this.add
      .bitmapText(this.gameWidth / 2, 440, 'pixelfont', controlsTextContent, 24)
      .setOrigin(0.5, 0.5);
    this.controlsText.setCharacterTint(0, tintLengths[0], true, 0xff2f56);
    this.controlsText.setCharacterTint(
      tintLengths[0],
      tintLengths[1],
      true,
      0x1b98e0
    );
    if (this.numPlayers > 2) {
      this.controlsText.setCharacterTint(
        tintLengths[0] + tintLengths[1],
        tintLengths[2],
        true,
        0x0ead69
      );
      if (this.numPlayers > 3) {
        this.controlsText.setCharacterTint(
          tintLengths[0] + tintLengths[1] + tintLengths[2],
          tintLengths[3],
          true,
          0xf2dc5d
        );
      }
    }

    // this.flyButton = this.add.bitmapText(this.gameWidth/2, 440, 'pixelfont', '>>', 24).setOrigin(0.5,0.5).setInteractive({useHandCursor:true}).on('pointerdown', () => this.makeBirdGo()).on('pointerup', () => this.makeBirdStop()).on('pointerout', () => this.makeBirdStop());

    this.input.keyboard.on('keydown', this.handleKeyboardDown, this);
    this.input.keyboard.on('keyup', this.handleKeyboardUp, this);

    if (this.input.gamepad.total < 1) {
      this.input.gamepad.once(
        'connected',
        function (pad) {
          this.input.gamepad.on('down', this.handleGamePadDown, this);
          this.input.gamepad.on('up', this.handleGamePadUp, this);
        },
        this
      );
    } else {
      this.input.gamepad.on('down', this.handleGamePadDown, this);
      this.input.gamepad.on('up', this.handleGamePadUp, this);
    }

    this.bird1.body.onOverlap = true;
    if (this.numPlayers > 1) {
      this.bird2.body.onOverlap = true;
      if (this.numPlayers > 2) {
        this.bird3.body.onOverlap = true;
        if (this.numPlayers > 3) {
          this.bird4.body.onOverlap = true;
        }
      }
    }

    this.events.on('shutdown', this.shutdown, this);
  }

  update() {
    this.physics.world.overlap(
      this.bird1,
      this.wallsLR,
      this.birdBounceLR,
      null,
      this
    );
    this.physics.world.overlap(
      this.bird1,
      this.wallsTB,
      this.birdBounceTB,
      null,
      this
    );
    this.physics.world.overlap(
      this.bird1,
      this.coins,
      this.collectCoin,
      null,
      this
    );
    this.physics.world.overlap(
      this.bird1,
      this.bombs,
      this.hitBomb,
      null,
      this
    );

    if (this.goBirds[0] && this.bird1.playable) {
      this.bird1.setAngularVelocity(0);
      this.physics.velocityFromAngle(
        this.bird1.angle,
        this.birdVelocities[0],
        this.bird1.body.velocity
      );
    } else {
      this.bird1.setAngularVelocity(this.birdAngularVelocities[0]);
      this.bird1.setVelocity(0, 0);
    }

    if (this.numPlayers > 1) {
      this.physics.world.overlap(
        this.bird2,
        this.wallsLR,
        this.birdBounceLR,
        null,
        this
      );
      this.physics.world.overlap(
        this.bird2,
        this.wallsTB,
        this.birdBounceTB,
        null,
        this
      );
      this.physics.world.overlap(
        this.bird2,
        this.coins,
        this.collectCoin,
        null,
        this
      );
      this.physics.world.overlap(
        this.bird2,
        this.bombs,
        this.hitBomb,
        null,
        this
      );

      if (this.goBirds[1] && this.bird2.playable) {
        this.bird2.setAngularVelocity(0);
        this.physics.velocityFromAngle(
          this.bird2.angle,
          this.birdVelocities[1],
          this.bird2.body.velocity
        );
      } else {
        this.bird2.setAngularVelocity(this.birdAngularVelocities[1]);
        this.bird2.setVelocity(0, 0);
      }

      if (this.numPlayers > 2) {
        this.physics.world.overlap(
          this.bird3,
          this.wallsLR,
          this.birdBounceLR,
          null,
          this
        );
        this.physics.world.overlap(
          this.bird3,
          this.wallsTB,
          this.birdBounceTB,
          null,
          this
        );
        this.physics.world.overlap(
          this.bird3,
          this.coins,
          this.collectCoin,
          null,
          this
        );
        this.physics.world.overlap(
          this.bird3,
          this.bombs,
          this.hitBomb,
          null,
          this
        );

        if (this.goBirds[2] && this.bird3.playable) {
          this.bird3.setAngularVelocity(0);
          this.physics.velocityFromAngle(
            this.bird3.angle,
            this.birdVelocities[2],
            this.bird3.body.velocity
          );
        } else {
          this.bird3.setAngularVelocity(this.birdAngularVelocities[2]);
          this.bird3.setVelocity(0, 0);
        }

        if (this.numPlayers > 3) {
          this.physics.world.overlap(
            this.bird4,
            this.wallsLR,
            this.birdBounceLR,
            null,
            this
          );
          this.physics.world.overlap(
            this.bird4,
            this.wallsTB,
            this.birdBounceTB,
            null,
            this
          );
          this.physics.world.overlap(
            this.bird4,
            this.coins,
            this.collectCoin,
            null,
            this
          );
          this.physics.world.overlap(
            this.bird4,
            this.bombs,
            this.hitBomb,
            null,
            this
          );

          if (this.goBirds[3] && this.bird4.playable) {
            this.bird4.setAngularVelocity(0);
            this.physics.velocityFromAngle(
              this.bird4.angle,
              this.birdVelocities[3],
              this.bird4.body.velocity
            );
          } else {
            this.bird4.setAngularVelocity(this.birdAngularVelocities[3]);
            this.bird4.setVelocity(0, 0);
          }
        }
      }
    }
  }

  shutdown() {
    //  We need to clear keyboard and gamepad events, or they'll stack up when the Menu is re-run
    this.input.keyboard.shutdown();
    this.input.gamepad.shutdown();
  }

  handleKeyboardDown(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.A:
      case Phaser.Input.Keyboard.KeyCodes.Q:
        this.makeBirdGo(this.bird1);
        break;
      case Phaser.Input.Keyboard.KeyCodes.L:
        if (this.numPlayers < 3) {
          this.makeBirdGo(this.bird2);
        } else if (this.numPlayers > 3) {
          this.makeBirdGo(this.bird4);
        }
        break;
      case Phaser.Input.Keyboard.KeyCodes.C:
        this.makeBirdGo(this.bird2);
        break;
      case Phaser.Input.Keyboard.KeyCodes.Y:
        if (this.numPlayers > 2) {
          this.makeBirdGo(this.bird3);
        }
        break;
    }
  }

  handleKeyboardUp(event) {
    event.stopPropagation(); // just in case
    switch (event.keyCode) {
      case Phaser.Input.Keyboard.KeyCodes.A:
      case Phaser.Input.Keyboard.KeyCodes.Q:
        this.makeBirdStop(this.bird1);
        break;
      case Phaser.Input.Keyboard.KeyCodes.L:
        if (this.numPlayers < 3) {
          this.makeBirdStop(this.bird2);
        } else if (this.numPlayers > 3) {
          this.makeBirdStop(this.bird4);
        }
        break;
      case Phaser.Input.Keyboard.KeyCodes.C:
        this.makeBirdStop(this.bird2);
        break;
      case Phaser.Input.Keyboard.KeyCodes.Y:
        if (this.numPlayers > 2) {
          this.makeBirdStop(this.bird3);
        }
        break;
    }
  }

  handleGamePadDown(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        switch (pad.index) {
          case 1:
            this.makeBirdGo(this.bird2);
            break;
          case 2:
            if (this.numPlayers > 2) {
              this.makeBirdGo(this.bird3);
            }
            break;
          case 3:
            if (this.numPlayers > 3) {
              this.makeBirdGo(this.bird4);
            }
            break;
          case 0:
          default:
            this.makeBirdGo(this.bird1);
        }
        break;
    }
  }

  handleGamePadUp(pad, button, value) {
    switch (button.index) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        switch (pad.index) {
          case 1:
            this.makeBirdStop(this.bird2);
            break;
          case 2:
            if (this.numPlayers > 2) {
              this.makeBirdStop(this.bird3);
            }
            break;
          case 3:
            if (this.numPlayers > 3) {
              this.makeBirdStop(this.bird4);
            }
            break;
          case 0:
          default:
            this.makeBirdStop(this.bird1);
        }
        break;
    }
  }

  updateTimer() {
    if (this.timer > 0) {
      this.timer = this.timer - 1;
      this.timerText.text = leftpad(this.timer, 2);
    }
    if (this.timer < 1) {
      let livingBird;
      this.sound.play('ouch');
      this.bird1.playable = false;
      if (this.bird1.alive) {
        this.bird1.anims.play('bye');
        livingBird = this.bird1;
      }
      this.bird2.playable = false;
      if (this.bird2.alive) {
        this.bird2.anims.play('bye-blue');
        if (!livingBird) {
          livingBird = this.bird2;
        }
      }
      if (this.numPlayers > 2) {
        this.bird3.playable = false;
        if (this.bird3.alive) {
          this.bird3.anims.play('bye-green');
          if (!livingBird) {
            livingBird = this.bird3;
          }
        }
        if (this.numPlayers > 3) {
          this.bird4.playable = false;
          if (this.bird4.alive) {
            this.bird4.anims.play('bye-yellow');
            if (!livingBird) {
              livingBird = this.bird4;
            }
          }
        }
      }
      livingBird.on(
        'animationcomplete',
        () => {
          this.scene.start('gameOver', {
            scores: this.scores,
            mode: 'Multi Player Blitz',
            numPlayers: this.numPlayers,
          }); // with num players
        },
        this
      );
    }
  }

  makeBirdGo(bird) {
    if (!this.goBirds[bird.index]) {
      this.goBirds[bird.index] = true;
      if (bird.playable) {
        switch (bird.index) {
          case 3:
            bird.anims.play('fly-yellow');
            break;
          case 2:
            bird.anims.play('fly-green');
            break;
          case 1:
            bird.anims.play('fly-blue');
            break;
          default:
            bird.anims.play('fly');
        }
      }
    }
  }

  makeBirdStop(bird) {
    this.goBirds[bird.index] = false;
    if (bird.playable) {
      switch (bird.index) {
        case 3:
          bird.anims.play('hover-yellow');
          break;
        case 2:
          bird.anims.play('hover-green');
          break;
        case 1:
          bird.anims.play('hover-blue');
          break;
        default:
          bird.anims.play('hover');
      }
    }
  }

  birdBounceLR(bird, wall) {
    if (!bird.playable || bird.bouncingLR) {
      return;
    }
    bird.playable = false;
    bird.bouncingLR = true;
    bird.body.velocity.set(0, 0);
    bird.angle = angleReflect(bird.angle, 90);
    if (bird.x > wall.x) {
      bird.x += 8;
    } else {
      bird.x -= 8;
    }
    this.physics.velocityFromAngle(
      bird.angle,
      this.birdVelocities[bird.index],
      bird.body.velocity
    );
    bird.bouncingLR = false;
    bird.playable = true;
  }

  birdBounceTB(bird, wall) {
    if (!bird.playable || bird.bouncingTB) {
      return;
    }
    bird.playable = false;
    bird.bouncingTB = true;
    bird.body.velocity.set(0, 0);
    bird.angle = angleReflect(bird.angle, 0);
    if (bird.y > wall.y) {
      bird.y += 8;
    } else {
      bird.y -= 8;
    }
    this.physics.velocityFromAngle(
      bird.angle,
      this.birdVelocities[bird.index],
      bird.body.velocity
    );
    bird.bouncingTB = false;
    bird.playable = true;
  }

  getAvailableSpace() {
    let bird1_index =
      parseInt((this.bird1.x - 106.5) / 25) +
      11 * parseInt((this.bird1.y - 102.5) / 25);
    let bird1_indexes = [
      bird1_index - 12,
      bird1_index - 11,
      bird1_index - 10,
      bird1_index - 9,
      bird1_index - 1,
      bird1_index,
      bird1_index + 1,
      bird1_index + 2,
      bird1_index + 9,
      bird1_index + 10,
      bird1_index + 11,
      bird1_index + 12,
    ];

    let bird2_index =
      parseInt((this.bird2.x - 106.5) / 25) +
      11 * parseInt((this.bird2.y - 102.5) / 25);
    let bird2_indexes = [
      bird2_index - 12,
      bird2_index - 11,
      bird2_index - 10,
      bird2_index - 9,
      bird2_index - 1,
      bird2_index,
      bird2_index + 1,
      bird2_index + 2,
      bird2_index + 9,
      bird2_index + 10,
      bird2_index + 11,
      bird2_index + 12,
    ];

    let bird_indexes = bird1_indexes.concat(bird2_indexes);

    if (this.numPlayers > 2) {
      let bird3_index =
        parseInt((this.bird3.x - 106.5) / 25) +
        11 * parseInt((this.bird3.y - 102.5) / 25);
      let bird3_indexes = [
        bird3_index - 12,
        bird3_index - 11,
        bird3_index - 10,
        bird3_index - 9,
        bird3_index - 1,
        bird3_index,
        bird3_index + 1,
        bird3_index + 2,
        bird3_index + 9,
        bird3_index + 10,
        bird3_index + 11,
        bird3_index + 12,
      ];

      bird_indexes = bird_indexes.concat(bird3_indexes);

      if (this.numPlayers > 3) {
        let bird4_index =
          parseInt((this.bird4.x - 106.5) / 25) +
          11 * parseInt((this.bird4.y - 102.5) / 25);
        let bird4_indexes = [
          bird4_index - 12,
          bird4_index - 11,
          bird4_index - 10,
          bird4_index - 9,
          bird4_index - 1,
          bird4_index,
          bird4_index + 1,
          bird4_index + 2,
          bird4_index + 9,
          bird4_index + 10,
          bird4_index + 11,
          bird4_index + 12,
        ];

        bird_indexes = bird_indexes.concat(bird4_indexes);
      }
    }

    let available_spaces = [];
    for (let i = 0; i < this.spaces.length; i++) {
      if (this.spaces[i] == 0 && bird_indexes.indexOf(i) < 0) {
        available_spaces.push(i);
      }
    }
    // console.log(available_spaces.length);
    if (available_spaces.length < 1) {
      return false;
    }
    let rand_index =
      available_spaces[Math.floor(Math.random() * available_spaces.length)];
    let y_index = parseInt(rand_index / 11);
    let x_index = parseInt(rand_index % 11);
    let x = x_index * 25 + 120;
    let y = y_index * 25 + 120;
    return { index: rand_index, x: x, y: y };
  }

  createACoin(first) {
    let available_location = this.getAvailableSpace();
    if (available_location === false) {
      return;
    }
    this.spaces[available_location.index] = 1; // for a coin
    let maxScore = Math.max(...this.scores);
    let opportunity = Math.min(maxScore * 5, 49);
    let selection = Math.floor(Math.random() * opportunity);
    let value = 1;
    if (selection >= 45) {
      selection = 'sprite-banana';
      value = 5;
    } else if (selection >= 35) {
      selection = 'sprite-pear';
      value = 3;
    } else if (selection >= 20) {
      selection = 'sprite-orange';
      value = 2;
    } else {
      selection = 'sprite-radar';
      value = 1;
    }
    let a_coin = this.add.sprite(
      available_location.x,
      available_location.y,
      selection
    );
    a_coin.setAlpha(0.1);
    a_coin.coin_value = value;
    this.tweens.add({
      targets: a_coin,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
    });
    this.physics.world.enable(a_coin);
    if (selection == 'sprite-banana') {
      a_coin.body.setSize(17, 15);
      a_coin.body.setOffset(20, 22);
    } else if (selection == 'sprite-pear') {
      a_coin.body.setSize(13, 16);
      a_coin.body.setOffset(22, 22);
    } else if (selection == 'sprite-orange') {
      a_coin.body.setSize(16, 14);
      a_coin.body.setOffset(20, 22);
    } else {
      a_coin.body.setSize(16, 14);
      a_coin.body.setOffset(20, 22);
    }
    a_coin.allowGravity = false;
    this.coins.add(a_coin);
  }

  createABomb() {
    let available_location = this.getAvailableSpace();
    if (available_location === false) {
      return;
    }
    this.spaces[available_location.index] = 2; // for a bomb
    let adj_index = available_location.index - 12;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 9;
    if (adj_index > 0) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 2;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 9;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    adj_index += 1;
    if (adj_index < this.spaces.length) {
      this.spaces[adj_index] = 2;
    }
    let rand_x = Math.floor(Math.random() * 5) - 2;
    let rand_y = Math.floor(Math.random() * 5) - 2;

    let a_bomb = this.add.sprite(
      available_location.x + rand_x,
      available_location.y + rand_y,
      'sprite-bomb'
    );
    this.physics.world.enable(a_bomb);
    a_bomb.body.setSize(24, 24);
    a_bomb.body.setOffset(16, 15);
    a_bomb.allowGravity = false;
    this.bombs.add(a_bomb);

    a_bomb.setAlpha(0.1);
    // a_bomb.setSize(32,32);
    this.tweens.add({
      targets: a_bomb,
      alpha: 1,
      duration: 200,
      repeat: 0,
      ease: 'quad.in',
    });
    a_bomb.anims.play('bomb-shine');
  }

  hitBomb(bird, bomb) {
    if (!bird.playable) {
      return;
    }
    if (bomb.alpha < 1) {
      return;
    } // bomb must be a valid threat!

    this.sound.play('ouch');
    bird.playable = false;
    switch (bird.index) {
      case 3:
        bird.anims.play('bye-yellow');
        break;
      case 2:
        bird.anims.play('bye-green');
        break;
      case 1:
        bird.anims.play('bye-blue');
        break;
      default:
        bird.anims.play('bye');
    }
    bomb.anims.play('bomb-bye');
    this.bombs.remove(bomb);
    bomb.on(
      'animationcomplete',
      () => {
        bomb.destroy();
      },
      this
    );
    bird.on(
      'animationcomplete',
      () => {
        bird.alive = false;
        if (this.numPlayers < 3) {
          if (this.bird1.alive == false && this.bird2.alive == false) {
            this.scene.start('gameOver', {
              scores: this.scores,
              mode: 'Multi Player Blitz',
              numPlayers: this.numPlayers,
            }); // with num players
          }
        } else if (this.numPlayers < 4) {
          if (
            this.bird1.alive == false &&
            this.bird2.alive == false &&
            this.bird3.alive == false
          ) {
            this.scene.start('gameOver', {
              scores: this.scores,
              mode: 'Multi Player Blitz',
              numPlayers: this.numPlayers,
            }); // with num players
          }
        } else {
          if (
            this.bird1.alive == false &&
            this.bird2.alive == false &&
            this.bird3.alive == false &&
            this.bird4.alive == false
          ) {
            this.scene.start('gameOver', {
              scores: this.scores,
              mode: 'Multi Player Blitz',
              numPlayers: this.numPlayers,
            }); // with num players
          }
        }
      },
      this
    );
  }

  killBomb(bomb) {
    this.bombs.remove(bomb);
    let killBombTween = this.tweens.add({
      targets: bomb,
      alpha: 0,
      duration: 200,
      repeat: 0,
      ease: 'quad.out',
    });
    killBombTween.on(
      'complete',
      () => {
        // this.bombs.kill(bomb);
        bomb.destroy();
      },
      this
    );
  }

  collectCoin(bird, coin) {
    if (!bird.playable) {
      return;
    }

    let animationKey = 'apple-bye';
    let soundKey = 'apple';
    if (coin.coin_value == 5) {
      animationKey = 'banana-bye';
      soundKey = 'banana';
    } else if (coin.coin_value == 3) {
      animationKey = 'pear-bye';
      soundKey = 'pear';
    } else if (coin.coin_value == 2) {
      animationKey = 'orange-bye';
      soundKey = 'orange';
    }
    this.coins.remove(coin);
    this.sound.play(soundKey);
    coin.anims.play(animationKey);
    // SpinnyBird.playSound('collect_coin');
    this.scores[bird.index] += coin.coin_value;

    let tintLengths = [0, 0, 0, 0];
    let scoreTextContent = '';
    for (let i = 0; i < this.numPlayers; i++) {
      let playerNum = i + 1;
      let playerScore = `P${playerNum}: ${this.scores[i]} `;
      scoreTextContent += playerScore;
      tintLengths[i] = playerScore.length;
    }
    this.scoreText.text = scoreTextContent;
    this.scoreText.setCharacterTint(0, tintLengths[0], true, 0xff2f56);
    this.scoreText.setCharacterTint(
      tintLengths[0],
      tintLengths[1],
      true,
      0x1b98e0
    );
    if (this.numPlayers > 2) {
      this.scoreText.setCharacterTint(
        tintLengths[0] + tintLengths[1],
        tintLengths[2],
        true,
        0x0ead69
      );
      if (this.numPlayers > 3) {
        this.scoreText.setCharacterTint(
          tintLengths[0] + tintLengths[1] + tintLengths[2],
          tintLengths[3],
          true,
          0xf2dc5d
        );
      }
    }

    coin.on(
      'animationcomplete',
      () => {
        coin.destroy();
        this.bombs.children.each(function (a_bomb) {
          if (true || a_bomb.active) {
            this.killBomb(a_bomb);
          }
        }, this);

        let maxScore = Math.max(...this.scores);
        if (maxScore >= 4) {
          this.numBombs = this.defaultNumBombs + 4;
        } else if (maxScore >= 3) {
          this.numBombs = this.defaultNumBombs + 3;
        } else if (maxScore >= 2) {
          this.numBombs = this.defaultNumBombs + 2;
        } else {
          this.numBombs = this.defaultNumBombs;
        }

        for (let i = 0; i < this.birdVelocities.length; i++) {
          this.birdVelocities[i] += 5;
          this.birdAngularVelocities[i] += 5;
        }

        this.spaces = new Uint8Array(this.spacesCount);
        for (let i = 0; i < this.numBombs; i++) {
          this.createABomb();
        }

        this.createACoin();
      },
      this
    );
  }
}
